export default __webpack_public_path__ + "locales/vi/CreateEditRoomDialog.json?hash=8aaae708ffeafb7636e9b49247113e4c";